module.exports = __webpack_public_path__ + "static/img/sx.393ecf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sx.png
// module id = 58t6
// module chunks = 0